<template>
  <div class="background" style="display: flex; width: 91%;margin: 2% 1% 10% 2.5%">
    <!--高级筛选-->
    <div class="advance-filter-page-left" style="background-color: #DBF0D1;border-radius: 20px;padding: 20px;height: 450px;max-width: 250px">
      <!--清除标题-->
      <div style="display: flex;justify-content: center;margin:-1% 0 0 0;font-size: medium;font-weight: 700;border-bottom-style:solid;border-color: #91D685;padding-bottom: 2%">
        <div style="">高级筛选</div>
      </div>
      <!--清除按钮-->
      <div style="margin:4% 2% 0 0">
        <el-button style="margin:0 0 0 -3%;width: 106%" type="info" plain round @click="resetOnaction()">清除</el-button>
      </div>
      <!--选择位置-->
      <b-row style="margin: 3% 0 0 -5%">
        <b-form-group label="选择关键字母位置">
          <b-form-radio-group
              v-model="selectedPosition"
              :options="optionsPosition"
              stacked
              plain
          ></b-form-radio-group>
        </b-form-group>
      </b-row>
      <!--教材-->
      <div style="margin: 3% 2% 0 -1%">
        <span class="demonstration" style="">教材选择</span>
        <el-cascader
            style="margin-top: 3%; width: 103%"
            v-model="valueBooks"
            :options="optionsBooks"
            :props="propsBooks"
            collapse-tags
            clearable
        ></el-cascader>
      </div>
      <!--词性-->
      <div style="margin: 3% 2% 0 -1%">
        <span class="demonstration" style="">词性选择</span>
        <el-select style="width: 103%;margin-top: 3%" clearable multiple v-model="selectAttribue" placeholder="请选择词性">
          <el-option
              v-for="item in optionsAttribute"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <!--词组-->
      <b-row style="margin: 5% 0 0 -5%">
        <el-switch
            v-model="valuePhrase"
            active-text="词组"
            active-color="#13ce66"
            inactive-color="#ff4949">
        </el-switch>
      </b-row>
              <!-- 备案 -->
        <div style="position: sticky;left:0;bottom:3%;width:100%;color:gray;margin-top: 40%;font-size: 7px;display: flex;justify-content: center;align-items: center;flex-direction: column">
          <a class="beian1" style="color: gray;text-align: center;" href="http://beian.miit.gov.cn/" target="_blank">津ICP备2021007309号-1</a>
          <a class="beian2" style="display: flex;background: none;color: gray;" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010102001035">
            <img class="img-beian" src=".././assets/beian.png" alt="" width="14px" height="14px">
            <div style="text-align: center;">津公网安备 12010102001035号</div>
          </a>
          <!-- <div>举报电话:13110028644</div> -->
          <div>举报邮箱:179254624@qq.com</div>
        </div>
    </div>
    <!--页面右侧-->
    <div class="page-right" style="flex-grow: 1">
      <div class="navigator" style="display: flex;justify-content: space-between">
        <!--盒子模型占位-->
        <div></div>
        <div class="title-search-group" style="display: flex;flex-direction: column;align-items: center">
          <!--标题-->
          <div class="title" style="font-size: 30px;color: black">
            <div>单词查询
              <b-spinner variant="warning" style="margin:0 0 8px 0" small v-show="showRefresh"></b-spinner>
              <b-spinner variant="warning" style="opacity: 0;margin:0 0 8px 0" small v-show="!showRefresh"></b-spinner>
            </div>
          </div>
          <!--搜索按钮组-->
          <div class="search-group" style="margin: 3% 0 1% 0">
            <div style="width: 500px">
              <b-form @submit="searchWordOnaction()">
                <b-input-group>
                  <b-form-input type="text"
                                v-model="searchText"
                                placeholder="输入要查询的文字"
                                id="submitResearch"

                  ></b-form-input>
                  <b-input-group-append>
                    <b-button variant="outline-success" @click="searchWordOnaction()">搜索</b-button>
                    <b-button variant="outline-danger" @click="resetOnaction()">重置</b-button>
                    <b-button :variant="variantDownload" :disabled=diabledUpdate @click="updateData()">
                      <b-icon icon="cloud-download" @click="updateData()"></b-icon>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form>
            </div>
          </div>
        </div>
        <!-- 登陆注册-->
        <div class="log-group" style="margin-top: 0px; margin-left: 0%;">
          <b-button class="log-button" variant="light" >
            <div @click="logout()" style="display: flex;justify-content: center;align-items: center">
              <div v-if="$store.state.userShow != '未登录'">
                <b-icon icon="person-circle"></b-icon>
              </div>
              <div v-else>
                <b-icon icon="person-dash"></b-icon>
              </div>
              <div style="margin-left: 5px; font-size: small">{{ $store.state.userShow }}</div>
            </div>
          </b-button>
        </div>
      </div>
      <!--结果展示-->
      <div class="result" style="margin-right: 0%">
        <b-container>
        <b-col cols="12" offset-md="1">
          <b-card-group style="margin: 2% 6% 3% -8%" deck v-show="showResult">
            <b-card header="查询结果">
              <b-list-group v-for="(word, index) in searchResult" :key="index">
                <b-list-group-item
                    :variant="classObje(index)"
                    button
                    v-b-modal.modal-tall
                    @click="popDialog3500(index)"
                >
                  <p>
                    <b-row>
                      <b-col cols="9">{{ word.英文 }} &nbsp;&nbsp;&nbsp; {{ word.词性 }}</b-col>
                      <b-col cols="">{{ word.单元 }}</b-col>
                    </b-row>
                  </p>
                  <p>{{ word.简单中文 }}</p>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>
          <div style="margin: 5px 0 0 0">
            {{ resultInfo }}
          </div>
        </b-col>

      </b-container>
      </div>




    </div>

    <!--弹窗展示-->
    <b-modal
        id="modal-tall"
        :title="searchTitle"
        size="xl"
        scrollable
        header-bg-variant="dark"
        header-text-variant="light"
        body-bg-variant="light"
        body-text-variant="dark"
        footer-bg-variant="warning"
        footer-text-variant="dark"
        modal-cancel="No"
    >
      <b-form-textarea
          id="textarea-auto"
          placeholder="Auto height (no-shrink) textarea"
          size="md"
          rows="8"
          max-rows="100"
          v-model="searchContent"
      ></b-form-textarea>
    </b-modal>
  </div>

</template>

<script>
import {Base64} from "js-base64";
import {Toast} from "vant";
import axios from "axios";
import Login from "@/components/login";

export default {
  name: 'homepage_pc',
  components: {},
  data(){
    return {
      // 搜索单词
      searchText: '',
      selectedPosition: 'begin', // 选择开头结尾包含
      optionsPosition: [
        { text: '开头', value: 'begin' },
        { text: '结尾', value: 'end' },
        { text: '包含', value: 'contain' },
      ],
      // 结果展示
      showResult: false,
      searchResult: '',
      searchContent: '',
      searchTitle: '',

      resultInfo: '选择条件，点击搜索', // 提示信息

      // 更新
      showRefresh: true,
      variantDownload: 'outline-secondary',
      diabledUpdate: true,
      // 教材选择
      optionsBooks: [
        {
          value: '七上',
          label: '七年级上',
          children: [
            { value: 'Starter 1', label: 'Starter 1' },
            { value: 'Starter 2', label: 'Starter 2' },
            { value: 'Starter 3', label: 'Starter 3' },
            { value: 'Starter 4', label: 'Starter 4' },
            { value: 'Module 1', label: 'Module 1' },
            { value: 'Module 2', label: 'Module 2' },
            { value: 'Module 3', label: 'Module 3' },
            { value: 'Module 4', label: 'Module 4' },
            { value: 'Module 5', label: 'Module 5' },
            { value: 'Module 6', label: 'Module 6' },
            { value: 'Module 7', label: 'Module 7' },
            { value: 'Module 8', label: 'Module 8' },
            { value: 'Module 9', label: 'Module 9' },
            { value: 'Module 10', label: 'Module 10' },
          ]
        },
        {
          value: '七下',
          label: '七年级下',
          children: [
            { value: 'Module 1', label: 'Module 1' },
            { value: 'Module 2', label: 'Module 2' },
            { value: 'Module 3', label: 'Module 3' },
            { value: 'Module 4', label: 'Module 4' },
            { value: 'Module 5', label: 'Module 5' },
            { value: 'Module 6', label: 'Module 6' },
            { value: 'Module 7', label: 'Module 7' },
            { value: 'Module 8', label: 'Module 8' },
            { value: 'Module 9', label: 'Module 9' },
            { value: 'Module 10', label: 'Module 10' },
            { value: 'Module 11', label: 'Module 11' },
            { value: 'Module 12', label: 'Module 12' },
          ]
        },
        {
          value: '八上',
          label: '八年级上',
          children: [
            { value: 'Module 1', label: 'Module 1' },
            { value: 'Module 2', label: 'Module 2' },
            { value: 'Module 3', label: 'Module 3' },
            { value: 'Module 4', label: 'Module 4' },
            { value: 'Module 5', label: 'Module 5' },
            { value: 'Module 6', label: 'Module 6' },
            { value: 'Module 7', label: 'Module 7' },
            { value: 'Module 8', label: 'Module 8' },
            { value: 'Module 9', label: 'Module 9' },
            { value: 'Module 10', label: 'Module 10' },
            { value: 'Module 11', label: 'Module 11' },
            { value: 'Module 12', label: 'Module 12' },
          ]
        },
        {
          value: '八下',
          label: '八年级下',
          children: [
            { value: 'Module 1', label: 'Module 1' },
            { value: 'Module 2', label: 'Module 2' },
            { value: 'Module 3', label: 'Module 3' },
            { value: 'Module 4', label: 'Module 4' },
            { value: 'Module 5', label: 'Module 5' },
            { value: 'Module 6', label: 'Module 6' },
            { value: 'Module 7', label: 'Module 7' },
            { value: 'Module 8', label: 'Module 8' },
            { value: 'Module 9', label: 'Module 9' },
            { value: 'Module 10', label: 'Module 10' },
          ]
        },
        {
          value: '九上',
          label: '九年级上',
          children: [
            { value: 'Module 1', label: 'Module 1' },
            { value: 'Module 2', label: 'Module 2' },
            { value: 'Module 3', label: 'Module 3' },
            { value: 'Module 4', label: 'Module 4' },
            { value: 'Module 5', label: 'Module 5' },
            { value: 'Module 6', label: 'Module 6' },
            { value: 'Module 7', label: 'Module 7' },
            { value: 'Module 8', label: 'Module 8' },
            { value: 'Module 9', label: 'Module 9' },
            { value: 'Module 10', label: 'Module 10' },
            { value: 'Module 11', label: 'Module 11' },
            { value: 'Module 12', label: 'Module 12' },
          ]
        },
        {
          value: '九下',
          label: '九年级下',
          children: [
            { value: 'Module 1', label: 'Module 1' },
            { value: 'Module 2', label: 'Module 2' },
            { value: 'Module 3', label: 'Module 3' },
            { value: 'Module 4', label: 'Module 4' },
            { value: 'Module 5', label: 'Module 5' },
            { value: 'Module 6', label: 'Module 6' },
            { value: 'Module 7', label: 'Module 7' },
            { value: 'Module 8', label: 'Module 8' },
          ]
        },
        {
          value: '必修一',
          label: '必修一',
          children: [
            { value: 'Unit 1', label: 'Unit 1' },
            { value: 'Unit 2', label: 'Unit 2' },
            { value: 'Unit 3', label: 'Unit 3' },
            { value: 'Unit 4', label: 'Unit 4' },
            { value: 'Unit 5', label: 'Unit 5' },
            { value: 'Unit 6', label: 'Unit 6' },
          ]
        },
        {
          value: '必修二',
          label: '必修二',
          children: [
            { value: 'Unit 1', label: 'Unit 1' },
            { value: 'Unit 2', label: 'Unit 2' },
            { value: 'Unit 3', label: 'Unit 3' },
            { value: 'Unit 4', label: 'Unit 4' },
            { value: 'Unit 5', label: 'Unit 5' },
            { value: 'Unit 6', label: 'Unit 6' },
          ]
        },
        {
          value: '必修三',
          label: '必修三',
          children: [
            { value: 'Unit 1', label: 'Unit 1' },
            { value: 'Unit 2', label: 'Unit 2' },
            { value: 'Unit 3', label: 'Unit 3' },
            { value: 'Unit 4', label: 'Unit 4' },
            { value: 'Unit 5', label: 'Unit 5' },
            { value: 'Unit 6', label: 'Unit 6' },
          ]
        },
        {
          value: '选修一',
          label: '选修一',
          children: [
            { value: 'Unit 1', label: 'Unit 1' },
            { value: 'Unit 2', label: 'Unit 2' },
            { value: 'Unit 3', label: 'Unit 3' },
            { value: 'Unit 4', label: 'Unit 4' },
            { value: 'Unit 5', label: 'Unit 5' },
            { value: 'Unit 6', label: 'Unit 6' },
          ]
        },
        {
          value: '选修二',
          label: '选修二',
          children: [
            { value: 'Unit 1', label: 'Unit 1' },
            { value: 'Unit 2', label: 'Unit 2' },
            { value: 'Unit 3', label: 'Unit 3' },
            { value: 'Unit 4', label: 'Unit 4' },
            { value: 'Unit 5', label: 'Unit 5' },
            { value: 'Unit 6', label: 'Unit 6' },
          ]
        },
        {
          value: '选修三',
          label: '选修三',
          children: [
            { value: 'Unit 1', label: 'Unit 1' },
            { value: 'Unit 2', label: 'Unit 2' },
            { value: 'Unit 3', label: 'Unit 3' },
            { value: 'Unit 4', label: 'Unit 4' },
            { value: 'Unit 5', label: 'Unit 5' },
            { value: 'Unit 6', label: 'Unit 6' },
          ]
        },
        {
          value: '选修四',
          label: '选修四',
          children: [
            { value: 'Unit 1', label: 'Unit 1' },
            { value: 'Unit 2', label: 'Unit 2' },
            { value: 'Unit 3', label: 'Unit 3' },
            { value: 'Unit 4', label: 'Unit 4' },
            { value: 'Unit 5', label: 'Unit 5' },
            { value: 'Unit 6', label: 'Unit 6' },
          ]
        },
      ],
      propsBooks: { multiple: true },
      valueBooks: '',

      // 词性
      selectAttribue: '',
      // selectAttribue: ['v'],
      optionsAttribute:[
        {
          value: 'v',
          label: '动词'
        },
        {
          value: 'n',
          label: '名词'
        },
        {
          value: 'adj',
          label: '形容词'
        },
        {
          value: 'adv',
          label: '副词'
        },
        {
          value: 'prep',
          label: '介词'
        },
        {
          value: 'conj',
          label: '连词'
        },
        {
          value: 'num',
          label: '数词'
        },
      ],
      // 词组
      valuePhrase: false,
    }
  },
  methods: {
    // 重置事件
    resetOnaction(){
      this.searchText = '';
      this.searchResult = '';
      this.showResult = false;
      this.selectedPosition = 'begin';
      document.getElementById('submitResearch').focus();
      this.selectAttribue = '';
      this.valuePhrase = false;
      this.valueBooks = '';
      this.$store.state.newWords = JSON.parse(Base64.decode(localStorage.getItem('newWords')))['data'];
      this.$store.state.gaokaoWords = JSON.parse(Base64.decode(localStorage.getItem('words3500')))['data'];
      this.resultInfo = '选择条件，点击搜索';
      // console.log(this.$store.state.newWords)

    },
    // 弹窗增加3500释义
    get3500Popup(fitlerResult, gaokaoWords){
      for(let i = 0; i < gaokaoWords.length; i++) {
        for(let j = 0; j < fitlerResult.length; j++) {
          if(fitlerResult[j].英文 == gaokaoWords[i].英文){
            fitlerResult[j]['2023中文'] = gaokaoWords[i].中文
            fitlerResult[j]['2024'] = gaokaoWords[i]['2024']
            fitlerResult[j]['2025'] = gaokaoWords[i]['2025']
            fitlerResult[j]['简单中文'] = gaokaoWords[i].中文.substr(0, 50)
            fitlerResult[j]['弹窗中文'] = fitlerResult[j]['弹窗中文'] + '-------------------------------' + '\n'
                + '3500释义（2023年）:\n'
                + fitlerResult[j]['2023中文'] + '\n'
                + '-------------------------------' + '\n'
                + '3500释义（2024年）:' + '\n'
                + fitlerResult[j]['2024'] + '\n'
                + '-------------------------------' + '\n'
                + '3500释义（2025年）:' + '\n'
                + fitlerResult[j]['2025'] + '\n'
          }
        }
      }
      // 没有3500中文增加占位
      for(let i = 0;i < fitlerResult.length; i++){
        if(fitlerResult[i]['2023中文'] == undefined){
          fitlerResult[i]['2023中文'] =  '无';
          fitlerResult[i]['2024'] =  '无';
          fitlerResult[i]['2025'] =  '无';
          fitlerResult[i]['简单中文'] = fitlerResult[i]['教材中文'];
          fitlerResult[i]['弹窗中文'] = fitlerResult[i]['弹窗中文'] + '-------------------------------' + '\n'
              + '3500释义（2023年）:\n'
              + fitlerResult[i]['2023中文'] + '\n'
              + '-------------------------------' + '\n'
              + '3500释义（2024年）:' + '\n'
              + fitlerResult[i]['2024'] + '\n'
              + '-------------------------------' + '\n'
              + '3500释义（2025年）:' + '\n'
              + fitlerResult[i]['2025'] + '\n'
        }
      }
      return fitlerResult
    },
    // 搜索空白
    searchBlankText(){
      let fitlerResult = [];
      let fitlerResult1 = [];
      let fitlerResult2 = [];
      // console.log('教材', this.$store.state.newWords);
      // console.log('3500', this.$store.state.gaokaoWords);
      if(this.valuePhrase){
        if(this.valueBooks.length == 0){
          this.$message.warning('搜索词组需要指定教材');
          return
        }else{
          // 搜索词组 + 教材
          console.log('词组 + 教材','完成')
          // console.log(this.valueBooks)
          for(let i=0;i<this.$store.state.newWords.length;i++){
            for(let j=0;j<this.valueBooks.length;j++) {
              if(this.$store.state.newWords[i].备注 == '词组' &&
                  this.$store.state.newWords[i].教材 == this.valueBooks[j][0] &&
                  this.$store.state.newWords[i].模块 == this.valueBooks[j][1]
              ){
                let obj = {
                  '英文': this.$store.state.newWords[i].英文,
                  '教材中文': this.$store.state.newWords[i].中文,
                  '简单中文': this.$store.state.newWords[i].中文,
                  '模块': this.$store.state.newWords[i].模块,
                  '教材': this.$store.state.newWords[i].教材,
                  // '备注': this.$store.state.newWords[i].备注,
                  // '词性': this.$store.state.newWords[i].词性,
                  '单元': this.$store.state.newWords[i].教材 + ' ' + this.$store.state.newWords[i].模块,
                  '弹窗中文': this.$store.state.newWords[i].教材 + ' ' + this.$store.state.newWords[i].模块 + '\n'
                            + this.$store.state.newWords[i].中文 + '\n',
                }
                fitlerResult.push(obj);
              }
            }
          }
        }
      }else{
        // 搜索所有
        if(this.valueBooks.length == 0){
          // 搜索所有单词 + 词性
          console.log('所有单词 + 词性');
          this.$message.warning('搜索单词需指定教材或字母');
          return
        }else{
          // 搜索教材单词 + 词性
          if(this.selectAttribue.length != 0){
            console.log('教材内单词 + 词性', '完成');
            // console.log(this.valueBooks)
            // 选了词性
            for(let i = 0;i < this.$store.state.newWords.length; i++) {
              for(let k = 0; k < this.$store.state.newWords[i].词性.split('/').length; k++) {
                let attr = this.$store.state.newWords[i].词性.split('/')[k];
                for (let m = 0; m < this.valueBooks.length; m++) {
                  for (let j = 0; j < this.selectAttribue.length; j++) {
                  // for(let k = 0; k < this.$store.state.newWords[i].词性.split('/').length; k++) {

                    if(this.selectAttribue[j] == attr &&
                      this.$store.state.newWords[i].教材 == this.valueBooks[m][0] &&
                      this.$store.state.newWords[i].模块 == this.valueBooks[m][1]
                    ){
                      const res = fitlerResult.find((el) => {
                        return el.英文 === this.$store.state.newWords[i].英文;
                      });
                      // console.log(res)
                      if(res != undefined) {
                        res['弹窗中文'] = res['弹窗中文'] + '-------------------------------' + '\n' + this.$store.state.newWords[i].教材 + ' ' + this.$store.state.newWords[i].模块 + '\n'
                            + this.$store.state.newWords[i].中文 + '\n'
                        continue
                      }
                      let obj = {
                        '英文': this.$store.state.newWords[i].英文,
                        '教材中文': this.$store.state.newWords[i].中文,
                        '模块': this.$store.state.newWords[i].模块,
                        '教材': this.$store.state.newWords[i].教材,
                        '备注': this.$store.state.newWords[i].备注,
                        '词性': this.$store.state.newWords[i].词性,
                        '单元': this.$store.state.newWords[i].教材 + ' ' + this.$store.state.newWords[i].模块,
                        '弹窗中文': this.$store.state.newWords[i].教材 + ' ' + this.$store.state.newWords[i].模块 + '\n'
                            + this.$store.state.newWords[i].中文
                            + '\n'
                      }
                      fitlerResult.push(obj);
                    }
                  }
                }
              }
            };
            fitlerResult = this.get3500Popup(fitlerResult, this.$store.state.gaokaoWords);

          }else{
            console.log('教材内单词 + 无词性', '完成')
            // 没选词性
            for(let i = 0;i < this.$store.state.newWords.length; i++) {
              for (let j = 0; j < this.valueBooks.length; j++) {
                if (
                    this.$store.state.newWords[i].教材 == this.valueBooks[j][0] &&
                    this.$store.state.newWords[i].模块 == this.valueBooks[j][1]
                ) {
                  const res = fitlerResult.find((el) => {
                    return el.英文 === this.$store.state.newWords[i].英文;
                  });
                  if(res != undefined) {
                    res['弹窗中文'] = res['弹窗中文'] + '-------------------------------' + '\n'
                        + this.$store.state.newWords[i].教材 + ' '
                        + this.$store.state.newWords[i].模块 + '\n'
                        + this.$store.state.newWords[i].中文 + '\n'
                    continue
                  }
                  // console.log(this.$store.state.newWords[i])
                  let obj = {
                    '英文': this.$store.state.newWords[i].英文,
                    '教材中文': this.$store.state.newWords[i].中文,
                    '模块': this.$store.state.newWords[i].模块,
                    '教材': this.$store.state.newWords[i].教材,
                    '备注': this.$store.state.newWords[i].备注,
                    '词性': this.$store.state.newWords[i].词性,
                    '单元': this.$store.state.newWords[i].教材 + ' ' + this.$store.state.newWords[i].模块,
                    '弹窗中文': this.$store.state.newWords[i].教材 + ' ' + this.$store.state.newWords[i].模块 + '\n'
                        + this.$store.state.newWords[i].中文 + '\n'
                  }
                  fitlerResult.push(obj);
                }
              }
            }
            fitlerResult = this.get3500Popup(fitlerResult, this.$store.state.gaokaoWords);
          }
        }
      }
      console.log('结果：', fitlerResult);
      this.searchResult = this.sortExpression(fitlerResult, '教材', '模块');
      this.showResult = true;
      // console.log(this.searchResult);
    },
    // 搜索单词
    searchWordOnaction(){
      if(this.searchText == ""){
        if(this.valueBooks == "" && this.selectAttribue == "" && this.valuePhrase == false){
          this.$message.warning('搜索不能为空');
          return
        }else{
          this.searchBlankText()
          return
        }
      };
      let res = new Promise((resolve, reject) => {
        this.resultInfo = '';
        this.ifUpdate();
        if(this.showRefresh == true){
          this.$message.error('数据加载中...');
          reject('error')
        };
        resolve('ok')
      })
      res.then( res =>{
        this.searchText = this.commonApi.trimStr(this.searchText.toLowerCase());
        this.searchText = this.commonApi.trimStr(this.searchText.toLowerCase());
        this.searchText = this.commonApi.trimStr(this.searchText.toLowerCase());
        function filter3500(beginWordsShow, endWords, containWords, attributeSelected, gaokaoWords){
          // 起始单词
          function filterBegin(beginWordsShow, gaokaoWords){
            let fitlerResult_1 = [];
            if(beginWordsShow.length != 0 ){
              for(let i = 0; i < gaokaoWords.length; i++){
                for(let j = 0; j < beginWordsShow.split(',').length; j++){
                  if(gaokaoWords[i]['英文'].indexOf(beginWordsShow.split(',')[j]) == 0){
                    let obj = {};
                    obj['2023中文'] = gaokaoWords[i]['中文']
                    obj['英文'] = gaokaoWords[i]['英文']
                    obj['词性'] = gaokaoWords[i]['词性']
                    obj['2024'] = gaokaoWords[i]['2024']
                    obj['2025'] = gaokaoWords[i]['2025']
                    fitlerResult_1.push(obj)
                  }
                }
              }
            }else{
              fitlerResult_1 = gaokaoWords
            }
            return fitlerResult_1
          }
          let fitlerResult1 = filterBegin(beginWordsShow, gaokaoWords);
          // console.log("fitlerResult1", fitlerResult1);

          // 末尾单词
          function filterEnd(endWords, fitlerResult1) {
            let fitlerResult_1 = [];
            // push 3500
            if (endWords.length != 0) {
              for (let i = 0; i < fitlerResult1.length; i++) {
                for(let j = 0; j < endWords.split(',').length; j++){
                  let start = fitlerResult1[i]['英文'].length - endWords.split(',')[j].length;
                  let arr = fitlerResult1[i]['英文'].substr(start, endWords.split(',')[j].length);
                  if (arr == endWords.split(',')[j]) {
                    let obj = {};
                    obj['2023中文'] = fitlerResult1[i]['中文']
                    obj['英文'] = fitlerResult1[i]['英文']
                    obj['词性'] = fitlerResult1[i]['词性']
                    obj['2024'] = gaokaoWords[i]['2024']
                    obj['2025'] = gaokaoWords[i]['2025']
                    fitlerResult_1.push(obj)
                  }
                }
              }
            } else {
              fitlerResult_1 = fitlerResult1
            }
            return fitlerResult_1
          }
          let fitlerResult2 = filterEnd(endWords, fitlerResult1);

          // 包含单词
          function filterContain(containWords, fitlerResult2){
            let fitlerResult3 = [];
            if(containWords.length != 0 ){
              for(let i = 0; i < fitlerResult2.length; i++){
                for(let j = 0; j < containWords.split(',').length; j++){
                  if(fitlerResult2[i]['英文'].indexOf(containWords.split(',')[j]) != -1){
                    let obj = {};
                    obj['2023中文'] = fitlerResult2[i]['中文']
                    obj['英文'] = fitlerResult2[i]['英文']
                    obj['词性'] = fitlerResult2[i]['词性']
                    obj['2024'] = gaokaoWords[i]['2024']
                    obj['2025'] = gaokaoWords[i]['2025']
                    fitlerResult3.push(obj)
                  }
                }
              }
            }else{
              fitlerResult3 = fitlerResult2
            }
            return fitlerResult3
          }
          let fitlerResult3 = filterContain(containWords, fitlerResult2)

          // console.log('fitlerResult3_包含', fitlerResult3)

          // 3500词性
          function filterAttribute(attributeSelected, fitlerResult3){
            let fitlerResult4 = [];
            let attributeSearch = "";
            if(attributeSelected.length != 0){
              for(let i = 0;i < fitlerResult3.length; i++){
                for(let j=0 ; j < attributeSelected.length; j++){
                  if(fitlerResult3[i]['词性'] !="" && fitlerResult3[i]['词性'] != NaN){
                    if(fitlerResult3[i]['词性'].search('/') == -1){
                      // 只有一个词性
                      attributeSearch = fitlerResult3[i]['词性']
                      if(attributeSelected[j] + '.' == attributeSearch){
                        fitlerResult4.push(fitlerResult3[i])
                      }
                    }else{
                      // 有多个词性
                      attributeSearch = fitlerResult3[i]['词性'].split('/')
                      for(let k = 0; k < attributeSearch.length; k++){
                        if(attributeSelected[j] + '.' == attributeSearch[k]
                            && fitlerResult3[i]['词性'] != NaN
                        ){
                          fitlerResult4.push(fitlerResult3[i])
                        }
                      }
                    }
                  }
                }
              }
            }else{
              fitlerResult4 = fitlerResult3
            }
            return fitlerResult4
          }
          let fitlerResult4 = filterAttribute(attributeSelected, fitlerResult3);

          return fitlerResult4
        };
        function filterBooks(beginWordsShow, endWords, containWords, attributeSelected, booksWords){
          // 起始单词
          function filterBegin(beginWordsShow, booksWords){
            let fitlerResult_1 = [];
            if(beginWordsShow.length != 0 ){
              for(let i = 0; i < booksWords.length; i++){
                if(booksWords[i]['英文'].indexOf(beginWordsShow) == 0){

                  const res = fitlerResult_1.find((el) => {
                    return el.英文 === booksWords[i].英文;
                  });
                  if(res != undefined){
                    res['弹窗中文'] = res['弹窗中文'] + '-------------------------------' + '\n' + booksWords[i].教材 + ' ' + booksWords[i].模块 + '\n'
                        + booksWords[i].中文 + '\n'
                    continue
                  };

                  // console.log(booksWords[i]);
                  let obj = {};
                  obj['教材中文'] = booksWords[i]['中文'];
                  obj['英文'] = booksWords[i]['英文'];
                  obj['词性'] = booksWords[i]['词性'];
                  obj['模块'] = booksWords[i]['模块'];
                  obj['备注'] = booksWords[i]['备注'];
                  obj['教材'] = booksWords[i]['教材'];
                  obj['单元'] = booksWords[i]['教材'] + ' ' + booksWords[i]['模块'];
                  obj['弹窗中文'] = booksWords[i].教材 + ' ' + booksWords[i].模块 + '\n'
                      + booksWords[i].中文
                      + '\n';
                  fitlerResult_1.push(obj);
                }
              }
            }else{
              fitlerResult_1 = booksWords
            }
            return fitlerResult_1
          }
          let fitlerResult1 = filterBegin(beginWordsShow, booksWords);
          // console.log('fitlerResult1_开始', fitlerResult1);

          // 末尾单词
          function filterEnd(endWords, fitlerResult1) {
            let fitlerResult_1 = [];
            if (endWords.length != 0) {
              for (let i=0;i<fitlerResult1.length;i++) {
                  let start = fitlerResult1[i]['英文'].length - endWords.length;
                  let arr = fitlerResult1[i]['英文'].substr(start, endWords.length);
                  if (arr == endWords) {
                    const res = fitlerResult_1.find((el) => {
                      return el.英文 === fitlerResult1[i].英文;
                    });
                    if(res != undefined){
                      res['弹窗中文'] = res['弹窗中文'] + '-------------------------------' + '\n' + fitlerResult1[i].教材 + ' ' + fitlerResult1[i].模块 + '\n'
                          + fitlerResult1[i].中文 + '\n'
                      continue
                    }
                    let obj = {};
                    obj['教材中文'] = fitlerResult1[i]['中文'];
                    obj['英文'] = fitlerResult1[i]['英文'];
                    obj['词性'] = fitlerResult1[i]['词性'];
                    obj['模块'] = fitlerResult1[i]['模块'];
                    obj['备注'] = fitlerResult1[i]['备注'];
                    obj['教材'] = fitlerResult1[i]['教材'];
                    obj['单元'] = fitlerResult1[i]['教材'] + ' ' + fitlerResult1[i]['模块'];
                    obj['弹窗中文'] = fitlerResult1[i].教材 + ' ' + fitlerResult1[i].模块 + '\n'
                        + fitlerResult1[i].中文
                        + '\n';
                    fitlerResult_1.push(obj)
                  }

              }
            } else {
              fitlerResult_1 = fitlerResult1
            }
            return fitlerResult_1
          }
          let fitlerResult2 = filterEnd(endWords, fitlerResult1);
          // console.log('fitlerResult2', fitlerResult2)

          // 包含单词
          function filterContain(containWords, fitlerResult2){
            let fitlerResult3 = [];
            if(containWords.length != 0 ){
              for(let i = 0; i < fitlerResult2.length; i++){
                if(fitlerResult2[i]['英文'].indexOf(containWords) != -1){
                  const res = fitlerResult3.find((el) => {
                    return el.英文 === fitlerResult2[i].英文;
                  });
                  if(res != undefined){
                    res['弹窗中文'] = res['弹窗中文'] + '-------------------------------' + '\n' + fitlerResult2[i].教材 + ' ' + fitlerResult2[i].模块 + '\n'
                        + fitlerResult2[i].中文 + '\n'
                    continue
                  }
                  let obj = {};
                  obj['教材中文'] = fitlerResult1[i]['中文'];
                  obj['英文'] = fitlerResult2[i]['英文'];
                  obj['词性'] = fitlerResult2[i]['词性'];
                  obj['模块'] = fitlerResult2[i]['模块'];
                  obj['备注'] = fitlerResult2[i]['备注'];
                  obj['教材'] = fitlerResult2[i]['教材'];
                  obj['单元'] = fitlerResult2[i]['教材'] + ' ' + fitlerResult2[i]['模块'];
                  obj['弹窗中文'] = fitlerResult2[i].教材 + ' ' + fitlerResult2[i].模块 + '\n'
                      + fitlerResult2[i].中文
                      + '\n';
                  fitlerResult3.push(obj)
                }
              }
            }else{
              fitlerResult3 = fitlerResult2
            }
            return fitlerResult3
          }
          let fitlerResult3 = filterContain(containWords, fitlerResult2)
          // console.log('fitlerResult3', fitlerResult3)

          // 教材词性
          function filterAttribute(attributeSelected, fitlerResult3){
            let fitlerResult4 = [];
            let attributeSearch = ""
            if(attributeSelected.length != 0){
              for(let i = 0;i < fitlerResult3.length; i++){
                for(let j = 0;j < attributeSelected.length; j++){
                  if(fitlerResult3[i]['词性'] != "" && fitlerResult3[i]['词性'] != NaN){
                    if(fitlerResult3[i]['词性'].search('/') == -1){
                      // 只有一个词性
                      attributeSearch = fitlerResult3[i]['词性'];
                      // console.log(attributeSearch, attributeSelected[j]);
                      if(attributeSelected[j] == attributeSearch){
                        fitlerResult4.push(fitlerResult3[i]);
                      }
                      // console.log(fitlerResult4)
                    }else{
                      // 有多个词性
                      attributeSearch = fitlerResult3[i]['词性'].split('/');
                      for(let k = 0; k < attributeSearch.length; k++){
                        // console.log(attributeSearch, attributeSelected[j]);
                        if(attributeSelected[j] == attributeSearch[k]){
                          fitlerResult4.push(fitlerResult3[i]);
                        }
                      }
                    }
                  }
                }
              }
            }else{
              fitlerResult4 = fitlerResult3
            }
            return fitlerResult4
          }
          let fitlerResult4 = filterAttribute(attributeSelected, fitlerResult3);
          // console.log(fitlerResult4)

          return fitlerResult4
        };
        let fitlerResult4 = [];
        let fitlerResult5 = [];
        // 搜索单词全局搜，搜索词组只搜教材
        if(this.selectedPosition == 'begin'){
          if(this.valuePhrase){
            fitlerResult5 = filterBooks(this.searchText, '', '', this.selectAttribue, this.$store.state.newWords);
          }else{
            fitlerResult4 = filter3500(this.searchText, '', '', this.selectAttribue, this.$store.state.gaokaoWords);
            fitlerResult5 = filterBooks(this.searchText, '', '', this.selectAttribue, this.$store.state.newWords);
          }
        }
        if(this.selectedPosition == 'end'){
          if(this.valuePhrase){
            fitlerResult5 = filterBooks('', this.searchText, '', this.selectAttribue, this.$store.state.newWords);
          }else{
            fitlerResult4 = filter3500('', this.searchText, '', this.selectAttribue, this.$store.state.gaokaoWords);
            fitlerResult5 = filterBooks('', this.searchText, '', this.selectAttribue, this.$store.state.newWords);
          }
        }
        if(this.selectedPosition == 'contain'){
          if(this.valuePhrase){
            fitlerResult5 = filterBooks('', '', this.searchText, this.selectAttribue, this.$store.state.newWords);
          }else{
            fitlerResult4 = filter3500('', '', this.searchText, this.selectAttribue, this.$store.state.gaokaoWords);
            fitlerResult5 = filterBooks('', '', this.searchText, this.selectAttribue, this.$store.state.newWords);
          }
        }
        // console.log('3500', fitlerResult4);
        // console.log('教材', fitlerResult5);

        // 合并结果
        if(this.valuePhrase){
          // 筛选词组
          this.searchResult = this.filterPhrase(fitlerResult5);
        }else{
          this.searchResult = this.mergeResult(fitlerResult5, fitlerResult4);
        }

        // 筛选教材
        // if(this.valueBooks.length != 0) this.searchResult = this.filterBooks(this.valueBooks, this.searchResult);
        return res
      }).catch(res => {
        this.showInfoLoading = false;
      })
      res.then(res => {
        // console.log('searchResult', this.searchResult);
        if(this.searchResult.length == 0){
          this.showResult = false;
          this.resultInfo = '无查询结果';
          return
        }
        this.showResult = true;
      })
    },
    // 合并俩个结果
    mergeResult(booksWords, gaokaoWords){
      // console.log("booksWords", booksWords);
      // console.log("gaokaoWords", gaokaoWords);

      // 交叉单词加上3500中文
      for(let i = 0; i < booksWords.length; i++){
        for(let j = 0; j < gaokaoWords.length; j++){
          if(booksWords[i].英文 === gaokaoWords[j].英文){
            booksWords[i]['词性'] = gaokaoWords[j]['词性'];
            booksWords[i]['2023中文'] = gaokaoWords[j]['2023中文'];
            booksWords[i]['2024'] = gaokaoWords[j]['2024']
            booksWords[i]['2025'] = gaokaoWords[j]['2025']
            booksWords[i]['弹窗中文'] = booksWords[i].弹窗中文 + '-------------------------------' + '\n'
                  + '3500释义（2023年）:' + '\n'
                  + gaokaoWords[j]['2023中文'] + '\n'
                  + '-------------------------------' + '\n'
                  + '3500释义（2024年）:' + '\n'
                  + gaokaoWords[j]['2024'] + '\n'
                  + '-------------------------------' + '\n'
                  + '3500释义（2025年）:' + '\n'
                  + gaokaoWords[j]['2025'] + '\n'
            booksWords[i]['简单中文'] = booksWords[i]['2023中文'].substr(0, 50);
            gaokaoWords.splice(j, 1);
          }
        }
      }
      // console.log(booksWords, gaokaoWords);

      // 没使用过的3500单词,教材信息补全空格
      for(let i = 0; i < gaokaoWords.length; i++){
        gaokaoWords[i]['教材中文'] = '';
        gaokaoWords[i]['模块'] = '';
        gaokaoWords[i]['教材'] = '';
        gaokaoWords[i]['单元'] = '';
        gaokaoWords[i]['备注'] = '';
        gaokaoWords[i]['弹窗中文'] = '3500释义（2023年）:' + '\n' + gaokaoWords[i]['2023中文'] + '\n'
            + '-------------------------------' + '\n'
            + '3500释义（2024年）:' + '\n'
            + gaokaoWords[i]['2024'] + '\n'
            + '-------------------------------' + '\n'
            + '3500释义（2025年）:' + '\n'
            + gaokaoWords[i]['2025'] + '\n';
        gaokaoWords[i]['简单中文'] = gaokaoWords[i]['2023中文'].substr(0, 50);
      }

      // 给3500单词补充课本信息
      if(this.selectAttribue.length != 0){
        for(let i = 0; i < gaokaoWords.length; i++){
          for(let j = 0; j < this.$store.state.newWords.length; j++){
            if(gaokaoWords[i].英文 == this.$store.state.newWords[j].英文){
              gaokaoWords[i]['弹窗中文'] =  this.$store.state.newWords[j].教材 + ' ' + this.$store.state.newWords[j].模块 + '\n'
                  + this.$store.state.newWords[j].中文 + '\n'
                  + '-------------------------------' + '\n'
                  + '3500释义（2023年）:' + '\n'
                  + gaokaoWords[i]['2023中文']
                  + '-------------------------------' + '\n'
                  + '3500释义（2024年）:' + '\n'
                  + gaokaoWords[i]['2024'] + '\n'
                  + '-------------------------------' + '\n'
                  + '3500释义（2025年）:' + '\n'
                  + gaokaoWords[i]['2025'] + '\n'
            }
          }
        }
      }
      // console.log(booksWords, gaokaoWords);

      // 教材单词,没有加过3500的补全空格
      for(let i = 0; i < booksWords.length; i++){
        if(!booksWords[i].hasOwnProperty('2023中文')){
          booksWords[i]['2023中文'] = '';
          booksWords[i]['2024'] = '';
          booksWords[i]['2025'] = '';
          booksWords[i]['弹窗中文'] = booksWords[i].弹窗中文 + '-------------------------------'
              + '\n' + '3500释义（2023年）:'
              + '无' + '\n'
              + '-------------------------------' + '\n'
              + '3500释义（2024年）:'
              + '无' + '\n'
              + '-------------------------------' + '\n'
              + '3500释义（2025年）:'
              + '无' + '\n'
          booksWords[i]['简单中文'] = booksWords[i]['教材中文'].substr(0, 50);
        }
      };

      if(gaokaoWords.length != 0 && booksWords.length != 0) return [...gaokaoWords, ...booksWords];
      if(gaokaoWords.length == 0) return booksWords;
      if(booksWords.length == 0) return gaokaoWords;
    },
    // 筛选教材
    filterBooks(listTextBooks, listWords){
      // console.log(listTextBooks, listWords);
      let listResult = [];
      for(let i = 0; i < listWords.length; i++){
        for(let j = 0;j < listTextBooks.length; j++){
          if(listTextBooks[j][0] == listWords[i]['教材'] && listTextBooks[j][1] == listWords[i]['模块']){
            listResult.push(listWords[i]);
          }
        }
      }
      // console.log('listResult', listResult)
      this.sortExpression(listResult)
      return listResult
    },
    // 排序
    sortExpression(_arr, book='教材', module='模块'){
      // 字典自定义排序
      let sortArr1 = ['七上','七下','八上','八下','九上','九下','必修一','必修二','必修三','选修一', '选修二', '选修三', '选修四'];
      let sortArr2 = ['Starter 1', 'Starter 2', 'Starter 3', 'Starter 4',
        'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6',
        'Module 7', 'Module 8', 'Module 9', 'Module 10', 'Module 11', 'Module 12',
        'Unit 1', 'Unit 2', 'Unit 3', 'Unit 4', 'Unit 5', 'Unit 6',]
      function getIndex(arr, key){
        return arr.indexOf(key) != -1 ? arr.indexOf(key) : 10000;
      }
      _arr.sort(function(a,b){
        if (getIndex(sortArr1, a[book]) == getIndex(sortArr1, b[book])) {
          if (getIndex(sortArr2, a[book]) == getIndex(sortArr2, b[book])) {
            try{
              if (getIndex(sortArr2, a[module]) > getIndex(sortArr2, b[module])) {
                return 1
              } else if (getIndex(sortArr2, a[module]) < getIndex(sortArr2, b[module])) {
                return -1
              } else {
                return 0
              }
            }catch (e) {
              return
            }
          }else{
            return getIndex(sortArr2, a[book]) > getIndex(sortArr2, b[book]) ? 1 : -1
          }
        }else{
          return getIndex(sortArr1, a[book]) > getIndex(sortArr1, b[book]) ? 1 : -1
        }
      });
      // console.log(_arr);
      return _arr
    },

    // 筛选词组
    filterPhrase(listWords){
      let listResult = [];
      for(let i = 0; i < listWords.length; i++){
        if(listWords[i].备注 === '词组') {
          let a = listWords[i].教材中文;
          listWords[i].简单中文 = a;
          listWords[i]['2023中文'] = '无';
          listWords[i]['2024'] = '无';
          listWords[i]['2025'] = '无';
          listResult.push(listWords[i])
        }
      }
      // 筛选词组按照教材排序
      this.sortExpression(listResult);
      return listResult
    },
    // 得到简单中文
    simplifyTranslation(){
      for(let i = 0; i < this.searchResult.length; i++){
        if(!this.valuePhrase){
          this.searchResult[i]['简单中文'] = this.searchResult[i].中文.substr(0,50);
        }else{
          this.searchResult[i]['简单中文'] = this.searchResult[i].中文;
        }

      }
    },
    // 得到教材信息
    getBooksInfo(){
      // 教材
      for(let i=0;i<this.searchResult.length;i++){
        for(let j=0;j<this.$store.state.newWords.length;j++){
            if(this.searchResult[i]['英文'] == this.$store.state.newWords[j]['英文']){
              // console.log(this.$store.state.newWords[j])

              if(this.valuePhrase == false) {
                // console.log('非词组')
                let books = this.$store.state.newWords[j]['教材'] + ' '
                    + this.$store.state.newWords[j]['模块'] + '\n'
                    + this.$store.state.newWords[j]['中文'] + '\n'
                    + '-------------------------------' + '\n'
                if(this.searchResult[i]['教材'] == ""){
                  this.searchResult[i]['教材'] = books;
                  // console.log(this.searchResult[i])
                }else{
                  this.searchResult[i]['教材'] = books + this.searchResult[i]['教材'];
                }
                this.searchResult[i]['单元'] = this.$store.state.newWords[j]['教材'] + "  " + this.$store.state.newWords[j]['模块'];

                continue
              } else {
                // console.log('词组')
                this.searchResult[i]['教材'] = this.$store.state.newWords[j]['教材'];
                this.searchResult[i]['单元'] = this.$store.state.newWords[j]['教材'] + ' ' + this.$store.state.newWords[j]['模块'];
                continue
              }
            }
            if(this.searchResult[i]['英文'] != this.$store.state.newWords[j]['英文'] && this.searchResult[i]['教材'] == undefined){
              // console.log(4)
              this.searchResult[i]['教材'] = "";
              this.searchResult[i]['单元'] = ""
            }
        }
      }
    },
    // 显示弹窗
    popDialog3500(index){
      this.searchContent = this.searchResult[index].弹窗中文;
      this.searchTitle = this.searchResult[index]['英文'];
    },
    // 更新数据
    updateData(){
      let res = new Promise((resolve, reject) => {
        this.showRefresh = true;
        // console.log(1)
        resolve(this.commonApi.getNewWords())
      })
      res = res.then( res => {
        // console.log(res)
        this.$store.state.newWords = res['data'];
        localStorage.removeItem("newWords");
        localStorage.setItem("newWords", Base64.encode(JSON.stringify(res)));
        // console.log(2)
        return this.commonApi.getWords3500()
      })
      res = res.then( res => {
        // console.log(3)
        // console.log(res)
        this.$store.state.gaokaoWords = res['data'];
        localStorage.removeItem("words3500");
        localStorage.setItem("words3500", Base64.encode(JSON.stringify(res)));
        this.variantDownload = 'outline-secondary';

        this.diabledUpdate = true
        return 'ok'
      })
      res.then( res => {
        // this.commonApi.mergeAllWords(this.$store.state.gaokaoWords, this.$store.state.newWords);
        this.showRefresh = false;
      })
    },
    // 判断是否更新
    ifUpdate(){
      let res = new Promise((resolve, reject) => {
        async function queryifUpdate() {
          let params = new URLSearchParams();
          params.append('method', 'words3500');
          params.append('version', JSON.parse(Base64.decode(localStorage.getItem("words3500")))['version']);
          return await axios.post('ifUpdate/', params).then((ret) => {
            return ret.data
          })
        }
        resolve(queryifUpdate())
      })
      res = res.then( res=>{
        console.log("是否更新3500?", res)
        if (res == true){
          this.variantDownload = 'warning';
          this.diabledUpdate = false;
        }
        async function queryifUpdate2(){
          let params = new URLSearchParams();
          params.append('method', 'newWords');
          params.append('version', JSON.parse(Base64.decode(localStorage.getItem("newWords")))['version']);
          // console.log(JSON.parse(localStorage.getItem("newWords")))
          return await axios.post('ifUpdate/', params).then( (ret) => {
            return ret.data
          })
        }
        return queryifUpdate2()
      })
      res.then( res => {
        console.log("是否更新books?", res)
        if (res == true){
          this.variantDownload = 'warning';
          this.diabledUpdate = false;
        }
      })
    },
    // 登出
    logout(){
      window.localStorage.clear();
      this.$router.push({ name: 'login_pc'});
    },

  },
  watch: {
    // 监视词性
    selectAttribue:{
      handler(newVal, oldVal){
        this.searchResult = '';
        if(newVal.length != 0){
          this.valuePhrase = false;
        }
        this.resultInfo = '选择条件，点击搜索';
        this.showResult = false;
        // this.$store.state.newWords = JSON.parse(Base64.decode(localStorage.getItem('newWords')))['data'];
        // this.$store.state.gaokaoWords = JSON.parse(Base64.decode(localStorage.getItem('words3500')))['data'];
      },
    },
    // 监视词组
    valuePhrase:{
      handler(newVal, oldVal){
        this.searchResult = '';
        if(newVal){
          this.selectAttribue = '';
        }
        this.resultInfo = '选择条件，点击搜索';
        this.showResult = false;
        this.$store.state.newWords = JSON.parse(Base64.decode(localStorage.getItem('newWords')))['data'];
        this.$store.state.gaokaoWords = JSON.parse(Base64.decode(localStorage.getItem('words3500')))['data'];
      },
    },
    // 监视教材
    valueBooks:{
      handler(newVal, oldVal){
        this.searchResult = '';
        this.$store.state.newWords = JSON.parse(Base64.decode(localStorage.getItem('newWords')))['data'];
        this.$store.state.gaokaoWords = JSON.parse(Base64.decode(localStorage.getItem('words3500')))['data'];
        this.resultInfo = '选择条件，点击搜索';
        this.showResult = false;
      },
    },
  },
  computed:{
    classObje() {
      return (attribute) => {
        if(attribute) {
          let key = getBit(parseInt(attribute) / 9)
          function getBit (value) {
            let s = value.toString();
            const res = s.substring(2, s.indexOf(".") + 2)
            if(res.indexOf('.') === 0){
              return parseInt(res.split('.')[1])
            }else{
              return parseInt(res)
            }
          }
          if(key == 1)return 'warning'
          if(key == 2)return 'secondary'
          if(key == 3)return 'success'
          if(key == 4)return 'danger'
          if(key == 5)return 'primary'
          if(key == 6)return 'info'
          if(key == 7)return 'light'
          if(key == 8)return 'dark'
          if(key == NaN)return 'warning'
        }
      }
    }
  },
  activated() {
  },
  mounted() {
    // console.log(this.$store.state.gaokaoWords)
    // prevent keydown

    // input获得焦点
    document.getElementById('submitResearch').focus();
    // 更新数据
    if(window.localStorage.getItem('newWords') == null || window.localStorage.getItem('words3500') == null){
      this.updateData();
    }else{
      this.showRefresh = false;
      this.ifUpdate();
    }
  },
}
</script>

<style scoped>
 .demonstration {
   margin-right: 0%;
 }

 .beian {
  /* margin-top: 10%;
  font-size: 8px; */
  /* background: none;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center */
}
.beian1 {
  /* background: none;
  color: white; */
}
.beian2 {
  /* display: flex;
  text-decoration:none;
  line-height:20px;
  background: none;
  color: white; */
}

.img-beian{
  margin: 4px 1px 0 2px;
}

</style>
